var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeeDepositDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4198_1966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 5.33325C12.2333 5.33325 5.33331 12.2333 5.33331 20.6666C5.33331 29.0999 12.2333 35.9999 20.6666 35.9999C29.1 35.9999 36 29.0999 36 20.6666C36 12.2333 29.1 5.33325 20.6666 5.33325ZM21.4333 10.8094C22.6381 10.8094 23.7333 11.7952 23.7333 13.1094C23.7333 14.4237 22.7476 15.4094 21.4333 15.4094C20.2286 15.4094 19.1333 14.4237 19.1333 13.1094C19.1333 11.7952 20.119 10.8094 21.4333 10.8094ZM20.2286 31.5094C18.2571 31.5094 16.8333 29.6475 17.3809 27.7856L19.3524 21.2142C19.5714 20.4475 19.0238 19.7904 18.2571 19.7904H17.2714C17.819 18.1475 19.3524 17.0523 21.1047 17.0523C23.0762 17.0523 24.5 18.9142 23.9524 20.7761L21.9809 27.3475C21.7619 28.1142 22.3095 28.7713 23.0762 28.7713H24.0619C23.5143 30.4142 21.9809 31.5094 20.2286 31.5094Z",
    fill: "#718096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4198_1966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeDepositDetails);
export default __webpack_public_path__ + "static/media/FeeDepositDetails.ce57d8cb057da91681b11b2e39a00d16.svg";
export { ForwardRef as ReactComponent };